import React, { forwardRef } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Flow brand exclusive icon
 */
export const MapMarkerLBOIcon: React.FC<SvgIconProps> = forwardRef((props, ref) => {
  return (
    <SvgIcon viewBox="2 2 20 20" ref={ref} {...props}>
      <path
        fillRule="evenodd"
        d="M12 21.2195C11.5605 20.7601 11.1486 20.3239 10.7627 19.9089C5.98966 14.776 5.1864 12.8769 5.1864 10.3667C5.1864 6.71506 8.3076 3.61426 12 3.61426C15.6924 3.61426 18.8136 6.71506 18.8136 10.3667C18.8136 12.8769 18.0103 14.776 13.2373 19.9089C12.8514 20.3239 12.4395 20.7601 12 21.2195ZM16.0687 13.5782C15.3481 14.7729 14.1167 16.314 12 18.596C9.88328 16.314 8.65194 14.7729 7.93133 13.5782C7.14085 12.2676 6.9864 11.4141 6.9864 10.3667C6.9864 7.72314 9.28769 5.41426 12 5.41426C14.7123 5.41426 17.0136 7.72314 17.0136 10.3667C17.0136 11.4141 16.8592 12.2676 16.0687 13.5782ZM9.99003 9.89997C10.6528 9.89997 11.19 9.36272 11.19 8.69999C11.19 8.03725 10.6528 7.5 9.99003 7.5C9.32729 7.5 8.79004 8.03725 8.79004 8.69999C8.79004 9.36272 9.32729 9.89997 9.99003 9.89997ZM15.81 11.7C15.81 12.3627 15.2728 12.9 14.61 12.9C13.9473 12.9 13.41 12.3627 13.41 11.7C13.41 11.0373 13.9473 10.5 14.61 10.5C15.2728 10.5 15.81 11.0373 15.81 11.7ZM13.3487 7.66187H15.218L10.7113 13.2778H8.84204L13.3487 7.66187Z"
      />
    </SvgIcon>
  );
});
